import './styles/CreateButton.scss';

import { Create } from '@mui/icons-material';
import { Button, ButtonProps, Skeleton } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface CreateButtonProps extends ButtonProps {
  renderSkeleton?: boolean;
}

export const CreateButton = (props: CreateButtonProps) => {
  const { t } = useTranslation();

  const { renderSkeleton, ...rest } = props;

  const CButton = () => (
    <Button
      {...rest}
      startIcon={!props.startIcon ? <Create /> : props.startIcon}
      variant="contained"
      className="button--create"
      onClick={props.onClick}
    >
      {props.children ? props.children : t(translations.common.create())}
    </Button>
  );

  // if (renderSkeleton) {
  //   return (
  //     <Skeleton variant={'rectangular'}>
  //       <CButton />
  //     </Skeleton>
  //   );
  // } else {
  return <CButton />;
  // }
};
